import React from 'react'
import { Button } from 'rsuite'
import PageToolbar from '../components/PageToolbar'
import TopLevelNav from '../components/TopLevelNav'
import { clearSession, logout } from '../redux/actions/auth'

export default function Disclaim() {
  return (
    <div className="custom-dashboard">
      <TopLevelNav />
      <PageToolbar />
      <div style={Styles.container}>
        <div style={Styles.child}>
          <div style={{ padding: 20, width: '100%' }}>
            <div>เนื่องจากท่านไม่ได้ยอมรับข้อกำหนด</div>
            <div style={{ fontWeight: 'bold' }}>
              “หนังสือแจ้งความประสงค์ในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
              ผู้รับทุนและผู้ร่วมโครงการของกองทุนสนับสนุนการสร้างเสริมสุขภาพ”
            </div>
            <div>ดังนั้น ท่านจึงไม่สามารถเข้าใช้งานระบบ</div>
            <Button
              appearance="primary"
              style={{ minWidth: 150, marginTop: 10 }}
              onClick={() => {
                clearSession(logout())
              }}
            >
              ออกจากระบบ
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

const Styles = {
  container: {
    textAlign: 'center',
    paddingTop: '20%',
    height: '300px',
    position: 'relative',
  },
  child: {
    margin: '0',
    position: 'absolute',
    marginTop: '20%',
    top: '50%',
    left: '50%',
    msTransform: 'translate(-50%, -50%)',
    transform: 'translate(-50%, -50%)',
    border: '2px solid #2da888',
  },
}
